export default __webpack_public_path__ + "static/media/special-events-mobile@2x.c756d89c.jpg";